import { ConfigProvider } from 'antd'
import React from 'react'
import { WHITE_LABEL_TENANT } from '../../helpers/Constants'
import LanguageFloatingGroup from '../../components/LanguageSelector'

export default function XerjoffConfigProvider({children}) {
  return (
     <ConfigProvider
      theme={{
        token: {
          colorPrimary: WHITE_LABEL_TENANT.XERJOFF.COLOR,
        },
      }}
     >
        
      <LanguageFloatingGroup/>
        {children}
      </ConfigProvider>
  )
}
